import { createSelector } from 'reselect';
import Immutable from 'immutable';

/**
 * Direct selector to the editTemplate state domain
 */
const selectEditTemplateDomain = () => (state) => state.get('editTemplate');
const selectEditTemplateReducer = (state) => state.get('editTemplate');

/**
 * Other specific selectors
 */

 const selectTemplateSchema = () => createSelector(
  selectEditTemplateReducer,
  (editTemplate) => {
    if (editTemplate) {
      const getData = editTemplate.get('templateSchema');
      if (getData) return getData.toJS();
    }
    return;
  }
);

const selectHistoryPages = () => createSelector(
  selectEditTemplateReducer,
  (editTemplate) => {
    if (editTemplate) {
      const getData = editTemplate.get('historyPages');
      if (getData) return getData.toJS();
    }
    return;
  }
);

const selectAnythingFn = (selectThis) => createSelector(
  selectEditTemplateReducer,
  (editTemplate) => {
    if (editTemplate) {
      const getData = editTemplate.get(selectThis);

      if (getData && (getData instanceof Immutable.Map || getData instanceof Immutable.List) && getData.toJS) return getData.toJS();
      if (getData) return getData;
    }
    return;
  }
);

const selectFormData = () =>
  createSelector(selectEditTemplateReducer, editTemplate =>
    editTemplate.get('formData').toJS()
  );

/**
 * Default selector used by EditTemplate
 */

const makeSelectEditTemplate = () => createSelector(
  selectEditTemplateDomain(),
  (substate) => substate.toJS()
);

export default makeSelectEditTemplate;
export {
  selectEditTemplateDomain,
  selectAnythingFn,
  selectTemplateSchema,
  selectFormData,
  selectHistoryPages
};
